var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[(false)?_c('div',{staticClass:"time"},[_c('EndDate',{attrs:{"endDate":_vm.endDate}})],1):_vm._e(),(false)?_c('div',{staticClass:"timeM"},[_c('EndDateM',{attrs:{"endDate":_vm.endDate}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }